import { createFileRoute, redirect } from '@tanstack/react-router';

/** Alias legacy `/bookings/car-history` → redirect a `/car-history` preservando i search params. */
export const Route = createFileRoute('/_app/bookings/car-history')({
  validateSearch: (s: Record<string, unknown>) => ({
    vehicleId: typeof s.vehicleId === 'string' ? s.vehicleId : undefined,
    employeeId: typeof s.employeeId === 'string' ? s.employeeId : undefined,
    /* Anche l'alias porta `bookingId`: un vecchio link salvato nei preferiti perderebbe altrimenti
       il legame con la trasferta proprio nel giro di redirect. */
    bookingId: typeof s.bookingId === 'string' ? s.bookingId : undefined,
  }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/car-history', search });
  },
});
